"use client"

import { useState } from "react"
import axiosInstance from "../../../api/Axiosinstance"

export const useSignup = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const signup = async (formData) => {
    try {
      setLoading(true)
      setError(null)

      // Prepare data for API call
      const registrationData = {
        firstName: formData.firstName.trim(),
        lastName: formData.lastName.trim(),
        email: formData.email.trim().toLowerCase(),
        mobile: formData.mobile.trim(),
        password: formData.password,
        confirmPassword: formData.confirmPassword,
        role: "user", 
        agreeToTerms: formData.agreeToTerms,
      }

      // Make API call using axios instance
      const response = await axiosInstance.post("/auth/signup", registrationData)

      // Return success response with data
      return {
        success: true,
        data: response.data,
      }
    } catch (err) {
      let errorMessage = "Registration failed. Please try again."

      if (err.response?.data?.message) {
        errorMessage = err.response.data.message
      } else if (err.response?.data?.error) {
        errorMessage = err.response.data.error
      } else if (err.response?.data?.errors) {
        // Handle validation errors from backend
        const backendErrors = err.response.data.errors
        if (Array.isArray(backendErrors) && backendErrors.length > 0) {
          errorMessage = backendErrors[0].msg || backendErrors[0]
        } else if (typeof backendErrors === "object") {
          errorMessage = Object.values(backendErrors)[0]
        }
      }

      setError(errorMessage)
      return {
        success: false,
        error: errorMessage,
      }
    } finally {
      setLoading(false)
    }
  }

  const clearError = () => {
    setError(null)
  }

  return {
    signup,
    loading,
    error,
    clearError,
  }
}
